module.exports = __webpack_public_path__ + "img/icon-tri-createtrivia.b4242b04.png";